<template>
    <section class="l-section l-section--main o-start">
        <div class="l-container l-container--main l-container--horizontalPaddings">
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--7">
                    <div class="l-row">
                        <div class="l-row__column l-row__column--8">
                            <h1 class="a-title">Uwaga</h1>
                            <p class="a-text">
                                Oferta nie istnieje
                            </p>
                            <br /><br />
                            <a-button @click="$router.push({ name: 'delivery-address' })">
                                Powrót do początku
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    metaInfo: {
        title: 'Oferta nie istnieje!'
    },
    created() {
        this.$store.dispatch('resetState')
    }
}
</script>
